<mat-form-field class="col-12" appearance="outline" [formGroup]="dateControl">
  <mat-date-range-input [rangePicker]="rangePicker">
    <input matStartDate placeholder="Start date" formControlName="startDate">
    <input matEndDate placeholder="End date" formControlName="endDate">
  </mat-date-range-input>
  <mat-hint>MM/YYYY – MM/YYYY</mat-hint>
  <mat-placeholder class="placeholder">{{ placeholder }}</mat-placeholder>
  <mat-datepicker-toggle matSuffix [for]="rangePicker">
    <div class="icon-override size-22 calendar-icon" matDatepickerToggleIcon></div>
  </mat-datepicker-toggle>
  
  <mat-date-range-picker #rangePicker startView="year" (monthSelected)="chosenMonthHandler($event, rangePicker)"
  (yearSelected)="chosenYearHandler($event)" [startAt]="startAt" disabled="false">
  </mat-date-range-picker>
  
</mat-form-field>